export enum BadgeText {
  ICON1_TEXT = 'Sum of Raw material, Raw material transportation and Processing Facility',
  ICON2_TEXT = 'Sum of Raw material, Raw material transportation Processing Facility and average of all product distribution',
}
